import React from 'react';
import { Flex, Box, Stack, Text, Image, Button, Link } from '@chakra-ui/react';
//import LoginForm from '../Components/Login/LoginForm';//LoginForm
import logoImg from '../Images/icon/logo.svg';
import g_logo from '../Images/icon/enviornment_logo.png';
import p_logo from '../Images/icon/poison_logo.png';
import s_logo from '../Images/icon/search_logo.svg';
import e_logo from '../Images/icon/experiment_logo.svg';
import linkImg from '../Images/icon/link.svg';
import circle_g from '../Images/icon/green_circle.svg';
import Footer from '../Components/General/Footer';
import LoginBg from '../Images/login_cut.png';

export default function Login() {
  return (
    <Stack overflowY="auto" overflowX="hidden" w="100%" bg="#DAF6E9">
      <Flex width="100vw" bg="#EBFCF4">
        <Box
          display={['none', 'none', 'none', 'block']}
          width="60vw"
          bg="#FFFFFF"
          bgPos={'center'}
          borderRightRadius="66px"
          pb="30px"
        >
          <Flex w="-webkit-fit-content" m={5} px={5} alignItems="center">
            <Image src={logoImg} />
            <Text fontSize="xl" color="#0B4654" ml={15} fontWeight="bold">
              {/* 化學署區塊鏈數位證書 */}
              化學雲區塊鏈應用
            </Text>
          </Flex>
          <Box
            mt={10}
            mr="7.5em"
            ml="7.5em"
            pb={8}
            borderBottomWidth="3px"
            borderColor="#F3F5F6"
          >
            <Text fontSize="2xl" fontWeight={'bold'} mb={4}>
              {/* 化學雲區塊鏈證書 */}
              區塊鏈證書
            </Text>
            <Text fontSize="16px" lineHeight="32.4px" mb={8}>
              {/* 化學雲區塊鏈證書是一個透過 Quorum
              聯盟鏈建置的前瞻示範案例，旨在提供一個安全、去中心化的數位證書平台，用來存儲和共享核准證件資料。它可以幫助廠商快速、高效地辨認持有之畫畫物質核可文件，減少審核時間和成本，同時也為消費者提供了更可靠、透明的企業資訊。 */}
              本區塊鏈證書是一個透過 Quorum 聯盟鏈建置的前瞻示範案例，旨在提供一個安全、去中心化的數位證書平台，用來存儲和共享核准證件資料。它可以幫助廠商快速、高效地辨認持有之畫畫物質核可文件，減少審核時間和成本，同時也為消費者提供了更可靠、透明的企業資訊。
              <br />
              <br />
              {/* 在化學雲區塊鏈證書平台上，每個證書都有一個獨一無二的證書 ID，這個
              ID
              可以用來查詢證書的詳細信息，包括證書的類型、發行日期、到期日期等等。所有的證書都是由主管機構發行的，並且必須經過平台上的驗證機制，才能被加入到證書庫中。 */}
              在區塊鏈證書平台上，每個證書都有一個獨一無二的證書 ID，這個 ID 可以用來查詢證書的詳細信息，包括證書的類型、發行日期、到期日期等等。所有的證書都是由主管機構發行的，並且必須經過平台上的驗證機制，才能被加入到證書庫中。
            </Text>
            <Button
              type="submit"
              bg="#07B464"
              width="220px"
              borderRadius="30px"
              onClick={() => {
                window.location.href = process.env.REACT_APP_FLORA_WEB;
              }}
            >
              自然人憑證登入
            </Button>
          </Box>
          <Flex
            w="-webkit-fit-content"
            margin="auto"
            mt={5}
            align-items={'center'}
          >
            <Image src={linkImg} />
            <Text fontSize="18px" color="#757575" ml={15}>
              相關連結
            </Text>
          </Flex>
          <Flex w="-webkit-fit-content" margin="auto" mt={5}>
            <Link
              href="https://www.epa.gov.tw/"
              bgImg={circle_g}
              width="120px"
              height="120px"
              position="relative"
              display={'flex'}
              justifyContent={'center'}
            >
              <Image
                src={g_logo}
                position="absolute"
                height="45px"
                top="16px"
              />
              <Text
                fontSize="14px"
                fontWeight={'bold'}
                position="absolute"
                top="65px"
                textAlign="center"
              >
                行政院環境部
              </Text>
            </Link>
            <Link
              href="https://www.tcsb.gov.tw/mp-1.html"
              bgImg={circle_g}
              width="120px"
              position="relative"
              mr={8}
              ml={8}
              display={'flex'}
              justifyContent={'center'}
            >
              <Image
                src={p_logo}
                position="absolute"
                height="45px"
                top="16px"
              />
              <Text
                fontSize="14px"
                fontWeight={'bold'}
                position="absolute"
                top="65px"
                textAlign="center"
              >
                化學物質管理署
              </Text>
            </Link>
            <Link
              href="https://tcscachemreg.epa.gov.tw/Epareg/OpenData/content/NewChemistPage.aspx"
              bgImg={circle_g}
              width="120px"
              position="relative"
              mr={8}
              display={'flex'}
              justifyContent={'center'}
            >
              <Image src={s_logo} position="absolute" top="20px" />
              <Text
                fontSize="13px"
                fontWeight={'bold'}
                position="absolute"
                top="60px"
                textAlign="center"
              >
                化學物質登錄資訊
                <br />
                公開查詢平台
              </Text>
            </Link>
            <Link
              href="https://tcscachemreg.epa.gov.tw/Epareg/content/masterpage/index.aspx"
              bgImg={circle_g}
              width="120px"
              position="relative"
              display={'flex'}
              justifyContent={'center'}
            >
              <Image src={e_logo} position="absolute" top="18px" />
              <Text
                fontSize="14px"
                fontWeight={'bold'}
                position="absolute"
                top="63px"
                textAlign="center"
              >
                化學物質
                <br />
                登錄平台
              </Text>
            </Link>
          </Flex>
        </Box>
        <Stack flexGrow={1} align="flex-end" position="relative">
          {/* <LoginForm /> remove LoginForm*/}
          <Box
            h="90vh"
            w="40vw"
            right="0px"
            bottom="0px"
            bgSize={'100% auto'}
            bgRepeat={'no-repeat'}
            bgPos={'bottom'}
            bgImg={LoginBg}
            position="absolute"
          ></Box>
        </Stack>
      </Flex>
      <Footer />
    </Stack>
  );
}
